import { useCallback } from 'react';
import { Checkbox, Header, Text, VStack } from '@direct-frontend/components';
import { useConfirm } from '#shared/lib/hooks';
import { constructorTestIds } from '#shared/lib/testids';
import { changeConstructorSectionStatus, getConstructorSectionSettings } from '../model/slices';
import { getConstructorCountChildren } from './useConstructorCountChildren';

export const useConstructorHideSection = () => {
    const { confirm, renderConfirmModal } = useConfirm();

    const hideSection = useCallback(
        async (pageId: string, sectionInstanceId: string) => {
            const sectionSettings = getConstructorSectionSettings(pageId, sectionInstanceId);

            if (!sectionSettings) {
                return;
            }

            let hideAll = false;

            const { childrenCount } = getConstructorCountChildren({ sectionId: sectionSettings.id });

            if (sectionSettings.section_type === 'parent' && childrenCount > 0) {
                const isConfirmed = await confirm({
                    title: null,
                    bodyText: (
                        <VStack gap="6">
                            <Header level="h2" textAlign="left">
                                Скрыть родительскую секцию?
                            </Header>
                            <Text size="m" role="supplementary" textAlign="left">
                                В родительской секции находятся настройки всех дочерних секций. Можно скрыть только её
                                или сразу всю группу
                            </Text>
                            <Checkbox
                                onChange={(isSelected) => (hideAll = isSelected)}
                                size="m"
                                data-testid={constructorTestIds.sectionHideComponentHideAll}
                            >
                                <Text>Также скрыть все дочерние секции вместе с родительской</Text>
                            </Checkbox>
                        </VStack>
                    ),
                    applyText: 'Скрыть',
                    'data-testid': constructorTestIds.sectionHideComponentModal,
                });

                if (!isConfirmed) {
                    return;
                }
            }

            changeConstructorSectionStatus(pageId, sectionInstanceId, 'hidden', hideAll);
        },
        [confirm]
    );

    return { hideSection, renderConfirmModal };
};
